var lastTicketDate = null;

$(document).ready(function() {
	var source = $("[name=source]").val();
	
	fillCountries();
	
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {

				if (item.category != currentCategory) {

					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	

	var re = null;
	$(".hotelAutoComplete").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term,
					zoneIds : $.map($('span.pickupDistrict'), function(obj){
					    return $(obj).attr('data-zoneid')
					}).join(',')
				},
			

				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
							return {
								value: item.name,
								key: item.id,
								category : item.type,
								name : item.name,
								zoneId : item.zoneId,
								hotelId : item.hotelId
							};
					});
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}
				
				
				
			});
		},
		minLength : 2,
		select: function (a, b) {
			$('[name="hotelId"]', this.form).val(b.item.hotelId);
			$("#pickupDistrict" + b.item.zoneId).show();
			$(this).data("autoCompleteResult", b.item.value);
		}
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="hotelId"]', this.form).val("");
	});
	
	 
	$('.notTCCheck').change(function() {
		var tcnoid = $(this).attr("tcnoid");
        if($(this).is(":checked")) {
        	$('#'+tcnoid).attr("disabled", "disabled");
        	$('#'+tcnoid).rules("remove","validate");
        	$('label[for="'+tcnoid+'"]').hide();
        } else {
        	$('#'+tcnoid).removeAttr("disabled");
        	$('#'+tcnoid).rules("add",{required:true});
        }    
    });
	
});
		
var guid = $('#guid').val();

$(".makeTicketFinal").click(function() {

	var isvalid = $("#ticketForm").valid() && emailValidation() && checkPassportInfo();

	if (!isvalid){
		$(".payDetailButtons").show();
		return false;
	}
	
	if(!checkAgreementStatus()){
		alert(FmtMessage.getMessage('js.payment.agreement.warning'));
		return false;
	}

    $('#alternativePaymentInstallmentId').val($(this).data("installmentid"));
	$('#alternativePaymentPayeeCode').val($(this).data("payeecode"));
	$('#alternativePaymentInstallmentCurrency').val($(this).data("installmentcurrency"));
	
	$(".payDetailButtons").hide();
	
	var nowTime = getNowTime();
	CommonPayment.uiErrors.push({elementName: "submit", warningText: "", userInput: "", errorType: 3, errorDate: nowTime});
	CommonPayment.uiEvents.push({elementName: "submit", startDate: nowTime, endDate: nowTime, userInput: "", eventType: 1});

	openLoaderBox();
	clearMasterpassCCInfoAndPaymentForm();
	saveReservationAjax("/tours/saveReservation?isAccount="+false,'#ticketForm','/tours/ccform/process?guid=' + guid);

});

$("#makeTicketMasterpassFinal").click(function() {

    var isvalid = $("#ticketForm").valid() && emailValidation() && checkPassportInfo();

    if (!isvalid){
        $(".payDetailButtons").show();
        return false;
    }

    if(!checkAgreementStatus()){
        alert(FmtMessage.getMessage('js.payment.agreement.warning'));
        return false;
    }
    else if(!checkMasterpassPhoneStatus()){
        alert(FmtMessage.getMessage('js.payment.masterpass.phone.warning'));
        return false;
    }
    else if(!checkMasterpassStatus()){
        alert(FmtMessage.getMessage('js.payment.masterpass.agreement.warning'));
        return false;
    }
    $(".payDetailButtonsMasterpass").hide();

    openLoaderBox();
    clearCCInfo();

    saveReservationAjax("/tours/saveReservation?isAccount="+false,'#ticketForm','/tours/ccform/process?guid=' + guid);

});

$("#makeTicketBkmFinal").click(function() {

    var isvalid = $("#ticketForm").valid() && emailValidation() && checkPassportInfo();

    if (!isvalid){
        $(".payDetailButtons").show();
        return false;
    }

    if(!checkAgreementStatus()){
        alert(FmtMessage.getMessage('js.payment.agreement.warning'));
        return false;
    }

    $(".payDetailButtons").hide();

    openLoaderBox();
    clearCCInfo();

    saveReservationAjax("/tours/saveReservation?isAccount="+false+"&isBkm="+true,'#ticketForm','/tours/ccform/process?guid=' + guid);

});

$("#makeTicketAccountFinal").click(function() {
	var isvalid = $("#ticketForm").valid() &&  emailValidation() && checkPassportInfo();
	if (!isvalid)
		return false;

	if(!checkAgreementStatus()){
		alert(FmtMessage.getMessage('js.payment.agreement.warning'));
		return false;
	}
	
	$(".payDetailButtons").hide();

	openLoaderBox();
	
	saveReservationAjax("/tours/saveReservation?isAccount="+true,'#ticketForm','/tours/ccform/process?guid=' + guid);
	
});

$("#makeReservation").click(function() {
	$(".creditCard-wrapper input").removeClass("required").removeClass("cvc_warn");
	$(".creditCard-wrapper select").removeClass("cc_expire_year_warn").removeClass("cc_expire_month_warn");
	var isvalid = $("#ticketForm").valid() &&  emailValidation() && checkPassportInfo();
	if (!isvalid) {
		$(".creditCard-wrapper input").addClass("required");
		$(".creditCard-wrapper #cv2").addClass("cvc_warn");
		$(".creditCard-wrapper #cc_expire_month").addClass("cc_expire_month_warn");
		$(".creditCard-wrapper #cc_expire_year").addClass("cc_expire_year_warn");
		return false;
	}

	if(!checkAgreementStatus()){
		$(".creditCard-wrapper input").addClass("required");
		$(".creditCard-wrapper #cv2").addClass("cvc_warn");
		$(".creditCard-wrapper #cc_expire_month").addClass("cc_expire_month_warn");
		$(".creditCard-wrapper #cc_expire_year").addClass("cc_expire_year_warn");
		alert(FmtMessage.getMessage('js.payment.agreement.warning'));
		return false;
	}
	
	$(".payDetailButtons").hide();

	openLoaderBox();
	
	saveReservationAjax("/tours/saveReservation?isReserve="+true+"&lastTicketDate="+lastTicketDate,'#ticketForm','/tours/ccform/process?guid=' + guid);
	
});

function checkPassportInfo(){
	var valid = true;

	if(valid && siteId != 2 && siteId != 11){
		var passNums = new Array();
		$('[itype="passNo"]').each(function(){
			if(passNums.length > 0 && $.inArray(this.value, passNums) > -1 ){
				alert(FmtMessage.getMessage('js.passNo.same.warning'));
				closeLoaderBox();
				valid = false;
				return false;
			}else{
				passNums[passNums.length] = this.value;
			}
		});
	}
	
	return valid;
}

function paymentOK(msg, orderId) {

	window.clearTimeout(CommonPayment.timeout);
	
	if (!CommonPayment.use3DSecure) {
		closeLoaderBox();
		
		try {
			$('[name=3dsecureFrameVpos]').attr('src', 'about:blank');
			$("[name=3dsecureFrameVpos]").contents().find("head").html('');
			$("[name=3dsecureFrameVpos]").contents().find("body").html('');
		} catch (e) {
		}
		
	} else {
		$('#bankprocess').hide();

		var modalDiv = $("#3dsecureDiv");
		modalDiv.dialog("close");

		try {
			$('[name=3dsecureFrame]').attr('src', 'about:blank');
			$("[name=3dsecureFrame]").contents().find("head").html('');
			$("[name=3dsecureFrame]").contents().find("body").html('');
		} catch (e) {
		}
	}

	$('payment-tabs').hide();

	setFormReadyOnly("ticketForm");
	
	showBankProcessMsg(msg, true);

	markSaleConversion();
	
	$('#ticketSuccessForm').find('#orderId').val(orderId);
	$('#ticketSuccessForm').submit();
	
}

function getHotelItemLabels(itemList){
	
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

